
import respUtility from '@/mixins/respUtility';

export default {
  name: 'AllFurnitureViewDynamicBanner',
  mixins: [respUtility],
  props: {
    deviceSpecificBanner: {
      type: Array,
    },
  },
  data() {
    return {
      isContentReady: false,
    };
  },
  methods: {
    updateStyles(cssText) {
      if (!this.$isSpider) {
        const styleElement = document.createElement('style');
        styleElement.textContent = cssText;
        document.head.appendChild(styleElement);
      }
    },
  },
  watch: {
    deviceSpecificBanner: {
      immediate: true,
      handler(newValue) {
        if (newValue?.[0]?.content?.style) {
          this.updateStyles(newValue[0].content.style);
          this.isContentReady = true;
        }
      },
    },
  },
};
